import * as React from "react";
import { GlobalStyles } from "../global-styles";
import { Footer } from "./footer";
import { Nav } from "./nav";
import styled from "@emotion/styled";

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;

  .bottom {
    margin-top: auto;
  }
`;

const Layout = ({ location, title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`;
  const isRootPath = location.pathname === rootPath;

  return (
    <StyledLayout className="global-wrapper" data-is-root-path={isRootPath}>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link
        href="https://fonts.googleapis.com/css2?family=Jost:wght@300;400&display=swap"
        rel="stylesheet"
      />
      <GlobalStyles />
      <div>
        <Nav />
        <main>{children}</main>
      </div>
      <div className="bottom">
        <Footer />
      </div>
    </StyledLayout>
  );
};

export default Layout;
